import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import React from "react";

const Dropdown = (props) => {
    const {options, value, label, onChange} = props;

    return (
        <FormControl>
            <InputLabel htmlFor={`${label}-select`}>{label}</InputLabel>
            <Select
                id={`${label}-select`}
                value={value}
                onChange={(event) => onChange(event.target.value)}>
                {Object.entries(options).map(([key, value]) => (
                    <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default Dropdown;
